<p-toast></p-toast>
<p-steps class="vertical-step" [model]="items" [readonly]="false"></p-steps>
